module.exports = __webpack_public_path__ + "static/media/canvas_summary.f7f8e28f.svg";